/* Explicit playback: no competing hover audio, original recordings preserved. */
if (!customElements.get('tdd-video-card')) customElements.define('tdd-video-card', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) { this.observer?.observe(this); return; }
    this.ready = true;
    const video = this.querySelector('video'), button = this.querySelector('button');
    if (!video || !button) return;
    video.loop = false;
    button.textContent = 'Play with sound';
    button.setAttribute('aria-label','Play video with sound');
    video.addEventListener('play', () => {
      document.querySelectorAll('tdd-video-card video').forEach(other => { if (other !== video) other.pause(); });
      this.classList.add('is-playing','has-started');
      button.textContent = 'Pause'; button.setAttribute('aria-label','Pause video'); button.setAttribute('aria-pressed','true');
    });
    video.addEventListener('pause', () => {
      this.classList.remove('is-playing'); button.textContent = 'Play'; button.setAttribute('aria-label','Play video with sound'); button.setAttribute('aria-pressed','false');
    });
    video.addEventListener('ended', () => { button.textContent = 'Replay'; });
    button.addEventListener('click', () => {
      if (!video.paused) { video.pause(); return; }
      video.muted = false;
      video.play().catch(() => { button.textContent = 'Tap to retry'; });
    });
    this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); this.querySelector('video')?.pause(); }
});

document.querySelectorAll('[data-comparison-scroll]').forEach(scroller => {
  const frame = scroller.closest('.tdd-comparison-frame');
  if (!frame) return;
  const updateCue = () => {
    frame.classList.toggle('has-scrolled', scroller.scrollLeft > 10);
    frame.classList.toggle('at-end', scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 8);
  };
  scroller.addEventListener('scroll', updateCue, {passive:true});
  window.addEventListener('resize', updateCue, {passive:true});
  updateCue();
});

document.addEventListener('click', event => {
  if (event.target.closest('a[href="#returns-details"]')) {
    const returns = document.querySelector('#returns-details');
    if (returns?.tagName === 'DETAILS') returns.open = true;
  }
  const motion = event.target.closest('.tdd-motion-toggle');
  if (motion) {
    const paused = motion.closest('.tdd-marquee').classList.toggle('is-paused');
    motion.setAttribute('aria-pressed',String(paused)); motion.textContent = paused ? 'Resume motion' : 'Pause motion';
  }
  const dialog = document.querySelector('.tdd-image-dialog');
  if (!dialog) return;
  const zoom = event.target.closest('[data-zoom-main], [data-zoom-src]');
  if (zoom) {
    const source = zoom.querySelector('img');
    const img = dialog.querySelector('img');
    img.src = zoom.dataset.zoomSrc || source?.src;
    img.alt = zoom.dataset.zoomAlt || source?.alt || 'Devotional book';
    dialog.classList.remove('is-zoomed');
    const toggle = dialog.querySelector('[data-zoom-toggle]'); toggle.textContent = 'Zoom in'; toggle.setAttribute('aria-pressed','false');
    dialog.showModal();
  }
  if (event.target.closest('[data-zoom-close]')) dialog.close();
  const toggle = event.target.closest('[data-zoom-toggle]');
  if (toggle) {
    const enlarged = dialog.classList.toggle('is-zoomed');
    toggle.setAttribute('aria-pressed',String(enlarged)); toggle.textContent = enlarged ? 'Fit image' : 'Zoom in';
  }
  if (event.target === dialog) {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }
});
